module.exports = __webpack_public_path__ + "img/1-08.6636993d.png";